<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link
      :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
      class="member-name"
    >{{ news.textParams[1] }}
    </router-link>
    has resigned as {{ news.textParams[2] }} effective from {{ news.textParams[3] }}
  </div>
</template>
